import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Mail, MailOpen, CheckCircle2 } from "lucide-react";

function fmtDate(iso) { try { return new Date(iso).toLocaleString("id-ID"); } catch { return ""; } }

const badge = (s) => ({
  baru: "bg-amber-100 text-amber-800",
  dibaca: "bg-blue-100 text-blue-800",
  selesai: "bg-emerald-100 text-emerald-800",
}[s] || "bg-slate-100 text-slate-700");

export default function AdminKontak() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  const load = () => api.get("/admin/kontak").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try { await api.put(`/admin/kontak/${id}/status?status=${status}`); toast.success("Status diperbarui"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  const remove = async (id) => {
    if (!window.confirm("Hapus pesan ini?")) return;
    try { await api.delete(`/admin/kontak/${id}`); toast.success("Terhapus"); setActive(null); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <div className="mb-6">
        <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold">Inbox</div>
        <h1 className="font-heading font-bold text-3xl text-[#003A5C]">Pesan Kontak</h1>
      </div>

      <div className="grid lg:grid-cols-[1.2fr_1fr] gap-6">
        <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden shadow-sm">
          {items.length === 0 && <div className="p-10 text-center text-slate-400">Belum ada pesan masuk.</div>}
          {items.map((it) => (
            <button key={it.id} onClick={() => { setActive(it); if (it.status === "baru") updateStatus(it.id, "dibaca"); }}
              className={`w-full text-left px-5 py-4 border-b border-slate-100 hover:bg-slate-50 ${active?.id === it.id ? "bg-[#F0F8FF]" : ""}`}>
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-[#003A5C] truncate">{it.nama}</div>
                  <div className="text-xs text-slate-500 truncate">{it.email}</div>
                </div>
                <span className={`text-[10px] uppercase font-bold px-2 py-0.5 rounded-full ${badge(it.status)}`}>{it.status}</span>
              </div>
              <div className="text-sm text-[#003A5C] font-medium mt-1 truncate">{it.subject}</div>
              <div className="text-xs text-slate-500 mt-1">{fmtDate(it.tanggal)}</div>
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl border border-slate-100 p-6 shadow-sm sticky top-6 self-start">
          {!active ? (
            <div className="text-center py-14 text-slate-400"><Mail className="w-10 h-10 mx-auto mb-3 opacity-40" />Pilih pesan untuk melihat detail</div>
          ) : (
            <>
              <div className="mb-4 pb-4 border-b border-slate-100">
                <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold">Dari</div>
                <div className="font-heading font-bold text-lg text-[#003A5C]">{active.nama}</div>
                <div className="text-sm text-slate-600">{active.email}</div>
                {active.instansi && <div className="text-sm text-slate-500">{active.instansi}</div>}
                <div className="text-xs text-slate-500 mt-1">{fmtDate(active.tanggal)}</div>
              </div>
              <div className="mb-4">
                <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold">Subjek</div>
                <div className="font-semibold text-[#003A5C]">{active.subject}</div>
              </div>
              <div className="mb-6">
                <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold mb-1">Pesan</div>
                <p className="text-slate-700 whitespace-pre-line leading-relaxed">{active.pesan}</p>
              </div>
              <div className="flex flex-wrap gap-2">
                <button onClick={() => updateStatus(active.id, "dibaca")} className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-50 text-blue-700 text-sm font-semibold hover:bg-blue-100">
                  <MailOpen className="w-4 h-4" /> Dibaca
                </button>
                <button onClick={() => updateStatus(active.id, "selesai")} className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-emerald-50 text-emerald-700 text-sm font-semibold hover:bg-emerald-100">
                  <CheckCircle2 className="w-4 h-4" /> Selesai
                </button>
                <button onClick={() => remove(active.id)} className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-red-50 text-red-700 text-sm font-semibold hover:bg-red-100 ml-auto">
                  <Trash2 className="w-4 h-4" /> Hapus
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
